import { SelectItem, SelectComponent } from 'ng2-select/ng2-select';
import { Subject } from 'rxjs';

const MAX_ENTRIES_TO_DISPLAY = 50;

export class Ng2SelectMultiHelper {
    rawValue: SelectItem[];
    private _cleanValue: any[];
    private cleanValueSubject = new Subject<any>();

    get cleanValue(): any[] {
        return this._cleanValue;
    }

    set cleanValue(val: any[]) {
        this._cleanValue = val;
        this.cleanValueSubject.next(val);
    }

    getCleanValueObservable() {
        return this.cleanValueSubject;
    }

    entries: SelectItem[];
    component: SelectComponent;
    // searchStringCheck: this variable was added to deal with a bug in the ng2-select component.
    // when a user clears the current input, instead of sending an empty string (or null) to the
    // (typed) event, the last input will be repeated. searchStringCheck is used as a workaround
    // to identify this and clear the select items when appropriate. If the bug this solves is
    // fixed in a future release of ng2-select, code related to searchStringCheck may become
    // un-necessary, or even cause the control to malfunction - if ng2-select is broken after
    // updating it, consider this as a possible cause.
    // commenting out searchStringCheck for now, it solves issues but creates others
    //searchStringCheck: string = null;
    // searchStringIgnoreOnce: see notes above for searchStringCheck
    //searchStringIgnoreOnce: boolean = false;

    static setupControl(): void {
        /* BEGIN HACK: the HighlightPipe used in ng2-select to highlight the portion of the item that matches what
         * the user has typed also prevents the item from being clicked properly. This hack will effectively
         * disable the HighlightPipe's functionality, so that the item is selectable in the UI.
         */
        // CSS hack instead.
        //var browserWindow = (<any>window);
        //if (browserWindow && browserWindow.SystemJS && browserWindow.SystemJS._loader && browserWindow.SystemJS._loader.modules) {
        //    var modules = browserWindow.SystemJS._loader.modules;
        //    var moduleName: any = null;
        //    for (var prop in modules) {
        //        if (prop.toString().indexOf('node_modules/ng2-select/select/select-pipes.js') > -1) { moduleName = prop }
        //    }
        //    if (moduleName) {
        //        modules[moduleName].module.HighlightPipe.prototype.transform = function (value, query) {
        //            return value;
        //        }
        //    }
        //}
        /* END HACK */
    }

    initialize(entries: any[], initialValues: any[]) {
        this.entries = entries.map((item) => {
            var entry = new SelectItem({ id: item.value, text: item.label });
            entry['textLower'] = item.label.toLowerCase();
            return entry;
        });

        this.buildInitialValues(initialValues);
        this.cleanValue = initialValues;
    }

    initializeForBrowse(entries: any[], initialValues: any[]) {
        this.entries = entries.map((item) => {
            var entry = new SelectItem({ id: item.value, text: item.label });
            entry['textLower'] = item.label.toLowerCase();
            return entry;
        });

        if (initialValues !== undefined && initialValues.length === 1) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].value === initialValues[0]) {
                    this.buildInitialValues(initialValues);
                    this.cleanValue = initialValues;
                    break;
                }
            }
        }       
    }

    initializeForEpspAcademics(entries: any[]) { //used in enhanced postsecondary school profile project
        this.entries = entries.map((item) => {
            var entry = new SelectItem({ text: item });
            entry['textLower'] = item.toLowerCase();
            return entry;
        });
    }

    setComponent(component: SelectComponent) {
        this.component = component;
        if (component) {
            this.component.items = [];
        }
    }

    private buildInitialValues(initialValues: any[]): void {
        // note: this might create performance issues if user selects a lot of colleges. Big-O n squared.
        if (initialValues) {
            this.rawValue = initialValues.map(currentItemId => {
                return this.entries.find(entry => {
                    return entry.id == currentItemId;
                });
            });
        }
    }

    onDataUpdate(newValue: SelectItem[]): void {
        if (newValue !== null) {
            this.cleanValue = newValue.map(item => item.id);
        }
        else {
            this.cleanValue = [];
        }
        //this.searchStringCheck = '';
        //this.searchStringIgnoreOnce = true;
    }

    onDataUpdateEpspAcademics(newValue: SelectItem[]): void {
        if (newValue !== null) {
            this.cleanValue = newValue.map(item => item.text);
        }
        else {
            this.cleanValue = [];
        }
        //this.searchStringCheck = '';
        //this.searchStringIgnoreOnce = true;
    }

    onTyped(searchString: string, characterDelay = 1): void {
        //if (searchString === this.searchStringCheck) {
        //    if (this.searchStringIgnoreOnce) {
        //        this.searchStringIgnoreOnce = false;
        //    } else {
        //        this.component.items = [];
        //        this.searchStringCheck = '';
        //    }
        //} else {
        if (searchString && searchString.length && searchString.length >= characterDelay) {
            var searchStringLower: string = searchString.toLowerCase();
            // might need to debounce this? fast typing can cause issues
            // a bit dangerous though, because typed event works so poorly (duplicate calls in some cases,
            // which wouldn't matter except that we are using them to trace where the box should have been emptied.)
            this.component.items = this.entries.filter((entry: any) => {
                return entry.textLower.includes(searchStringLower);
            }).slice(0, MAX_ENTRIES_TO_DISPLAY); // possible optimization: stop when MAX_ENTRIES_TO_DISPLAY found instead of processing whole list
            //this.searchStringCheck = searchString;
        }
        // access private method of the picker
        (<any>this.component).open();
    }

    setSelectedItem(id: number, text: string) {

        this.cleanValue = [Number(id)];
        
        var selectedItem = new SelectItem({ id: id, text: text });
        this.rawValue = [selectedItem];

    }

    clearSelectedItem() {
        this.cleanValue = [];
        this.rawValue = [];
    }
}

